module.exports = __webpack_public_path__ + "static/media/brand-car-wreck-rocklea.8f747268.png";